import React from "react";
import { useTranslation } from "react-i18next";
import "./home.css";

const STEPS = [
  { icon: "fas fa-search", title: "home_step1_title", text: "LOOK_FOR_A_LAWYER_DESCRIPTION" },
  { icon: "far fa-calendar-alt", title: "home_step2_title", text: "SEE_PROFILE_DESCRIPTION" },
  { icon: "far fa-bell", title: "home_step3_title", text: "TAKE_HIS_CONTACT_INFORMATION_DESCRIPTION" },
];

export default function HowToFindLawyer() {
  const { t } = useTranslation();
  return (
    <section className="avc-section avc-steps">
      <div className="container">
        <div className="avc-section__header avc-section__header--wide">
          <span className="avc-eyebrow avc-eyebrow--dark">
            {t("home_steps_eyebrow")}
          </span>
          <h2 className="avc-section__title avc-section__title--underlined">
            {t("Why_make_an_appointment_with_AvoConsulte")}
          </h2>
          <p className="avc-section__lead">
            {t("Why_make_an_appointment_with_AvoConsulte_description")}
          </p>
        </div>
        <div className="avc-steps__grid">
          {STEPS.map((step, index) => (
            <article className="avc-step" key={step.title}>
              <span className="avc-step__number">{index + 1}</span>
              <span className="avc-step__icon">
                <i className={step.icon} aria-hidden="true"></i>
              </span>
              <h3 className="avc-step__title">{t(step.title)}</h3>
              <p className="avc-step__text">{t(step.text)}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
